import React from 'react'
import axios from "axios";
import {baseUrl} from "../../../scripts/env";
import l8n from 'l8n';

class JivositeWidget extends React.Component {
  state = {
    isLoading: false,
  }

  componentDidMount = async () => {
    const {isLoading} = this.state;
    if (isLoading) {
      return;
    }

    const widgetConfig = await this.fetch()
    this.injectScript(widgetConfig)
  }

  fetch = async () => {
    this.setState({isLoading: true})
    const {data} = await axios({url: `${baseUrl}/widget/${l8n.locale}/settings`});

    return data
  }

  injectScript = (widgetConfig) => {
    const {public_id, code_host} = widgetConfig
    const widgetPublicId = public_id || 'vUPtwEr0lR'
    const widgetScript = document.createElement('script')

    widgetScript.async = true
    widgetScript.src = `//${code_host}/widget.js`
    widgetScript.setAttribute('jv-id', widgetPublicId)

    document.head.appendChild(widgetScript);
  }

  render() {
    return null
  }
}

export default JivositeWidget



// WEBPACK FOOTER //
// ./src/components/CustomComponents/JivositeWidget/index.js